<template>
  <div class="protocol-selector">
    <div class="row">
      <div class="box">
        <img v-if="isCheck" src="../../../assets/img-v2/ic_checkbox_selected.png" class="checkbox" @click="onChange(false)" />
        <img v-else src="../../../assets/img-v2/ic_checkbox.png" class="checkbox" @click="onChange(true)" />
      </div>
      
      <div class="link" @click="onOpenProtocol">
        <span class="label">阅读并同意</span>
        <span>《{{ protocolTitle }}》</span>
      </div>
    </div>

    <VanDialog
      v-model="isShowProtocol"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="true"
      class-name="protocol-dialog"
    >
      <div class="container">
        <div class="bg"></div>
        <div class="title">{{ protocolTitle }}</div>
        <div v-html="protocolContent" class="content"></div>
        <div class="bottom">
          <div class="btn" @click="onConfirm">同意</div>
        </div>
      </div>
    </VanDialog>
  </div>
</template>

<script>
import { getProtocolContent, getProtocolTitle } from "@/views/home/protocol";

export default {
  name: "ProtocolSelector",
  model: {
    prop: "isSelect",
    event: "change",
  },
  props: {
    isSelect: {
      type: Boolean,
      default: false,
    },
    ticketConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowProtocol: false,
      isCheck: false,
    };
  },
  computed: {
    // 优先级：购票端配置购票协议标题 > 本地配置
    protocolTitle() {
      const cityId = this.$AppService.getCityId();
      const { protocolTitle } = this.ticketConfig || {};
      return protocolTitle ? protocolTitle : getProtocolTitle(cityId);
    },
    // 优先级：购票端配置购票协议内容 > 本地配置
    protocolContent() {
      const cityId = this.$AppService.getCityId();
      const { protocolContent } = this.ticketConfig || {};
      return protocolContent ? protocolContent : getProtocolContent(cityId);
    },
  },
  watch: {
    isSelect: {
      immediate: true,
      handler(val) {
        this.isCheck = val;
      },
    },
  },
  methods: {
    onOpenProtocol() {
      this.isShowProtocol = true;
    },
    onChange(val) {
      this.$emit("change", val);
    },
    onConfirm() {
      this.isShowProtocol = false;
      this.$emit("change", true);
    },
  },
};
</script>

<style scoped lang="scss">
.protocol-selector {
  display: flex;
  justify-content: center;

  .row {
    display: flex;
    align-items: flex-start;
  }

  .box {
    padding: 10px 5px 0 10px;
  }

  .checkbox {
    width: 16px;
    height: 16px;
  }

  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    color: #7c818e;
  }

  .link {
    flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    color: #006efa;
    padding-top: 10px;
  }

  .container {
    position: relative;
    padding: 0 10px 0 20px;
  }

  .bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 120px;
    background: linear-gradient(180deg, #bddeff 0%, #ffffff 100%),
      linear-gradient(193deg, #d9fff3 0%, rgba(255, 255, 255, 0) 100%);
  }

  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 25px 10px 23px 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }

  .content {
    position: relative;
    max-height: 360px;
    overflow-y: auto;
    padding-bottom: 20px;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: justify;
    font-style: normal;
  }
  .bottom {
    height: 88px;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #eeeeee;
    border-radius: 0px 0px 20px 20px;
    display: flex;
    align-items: center;
  }
  .btn {
    width: 100%;
    height: 48px;
    background: #006efa;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}

.protocol-dialog {
  width: calc(100% - 20px);
  top: unset;
  bottom: calc(24px + constant(safe-area-inset-bottom));
  bottom: calc(24px + env(safe-area-inset-bottom));
  border-radius: 28px;
  padding: 0;
  transform: translate3d(-50%, 0, 0);
  ::v-deep .van-dialog__header {
    padding: 0;
    width: 100% !important;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    border-bottom: 1px solid #eeeeee;
  }
  ::v-deep .van-dialog__footer {
    border: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #006efa;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}
</style>
